module.exports = __webpack_public_path__ + "img/头部bg@2x.387f3969.png";